import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LegalPages.css';

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-container">
      <div className="legal-content">
        <button className="legal-back-btn" onClick={() => navigate(-1)}>← Back</button>

        <h1 className="legal-title">Terms &amp; Conditions</h1>
        <p className="legal-updated">Last Updated: May 21, 2026</p>

        <section className="legal-section">
          <h2>1. Introduction</h2>
          <p>Welcome to myOmni ("App"), operated by Enhance Technology Solutions (FlexPrime) ("Company," "we," "us," or "our"). By downloading, accessing, or using myOmni, you agree to be bound by these Terms and Conditions ("Terms"). If you do not agree, do not use the App.</p>
        </section>

        <section className="legal-section">
          <h2>2. Eligibility</h2>
          <p>You must be at least 13 years old (or older if required by your jurisdiction) to use myOmni. By using the App, you represent that you meet this requirement.</p>
        </section>

        <section className="legal-section">
          <h2>3. Account Registration</h2>
          <p>To use core features (digital business card, link in bio), you must create an account. You agree to:</p>
          <ul>
            <li>Provide accurate, current, and complete information.</li>
            <li>Maintain the security of your login credentials.</li>
            <li>Notify us immediately of any unauthorized use.</li>
          </ul>
          <p>You are responsible for all activities under your account.</p>
        </section>

        <section className="legal-section">
          <h2>4. Description of Services</h2>
          <p>myOmni provides:</p>
          <ul>
            <li><strong>Digital business card:</strong> Create, customize, and share virtual business cards.</li>
            <li><strong>Link in bio:</strong> Compile multiple URLs into a single landing page.</li>
          </ul>
          <p>We may update, modify, or discontinue features with reasonable notice.</p>
        </section>

        <section className="legal-section">
          <h2>5. User Content</h2>
          <p>You retain ownership of any content you upload (e.g., profile info, links, images). By posting content, you grant myOmni a worldwide, non-exclusive, royalty-free license to host, store, display, and share your content solely to operate the App.</p>
          <p>You agree not to post:</p>
          <ul>
            <li>Illegal, infringing, defamatory, obscene, or harmful content.</li>
            <li>Links to malware, phishing sites, or deceptive pages.</li>
            <li>False or misleading business information.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Prohibited Uses</h2>
          <p>You may not:</p>
          <ul>
            <li>Use the App for spam, scams, or fraudulent activities.</li>
            <li>Scrape, copy, or reverse-engineer the App.</li>
            <li>Interfere with the App's security or performance.</li>
            <li>Impersonate another person or entity.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>7. Paid Features and Subscriptions</h2>
          <p>Some features (e.g., advanced analytics, custom domains, team sharing) may require payment. Subscription fees (if any) will be clearly presented in the App. Payments are processed by third-party providers (e.g., Apple App Store, Google Play).</p>
          <ul>
            <li><strong>Auto-renewal:</strong> Subscriptions renew automatically unless turned off 24 hours before the period ends.</li>
            <li><strong>Refunds:</strong> Handled by the respective app store; we do not issue direct refunds unless required by law.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>8. Intellectual Property</h2>
          <p>The App's code, design, logos, and "myOmni" name are owned by myOmni LLC. You may not copy, modify, or distribute them without written permission.</p>
        </section>

        <section className="legal-section">
          <h2>9. Third-Party Links</h2>
          <p>Your "link in bio" may point to external sites. We are not responsible for the content, privacy policies, or practices of any third-party websites.</p>
        </section>

        <section className="legal-section">
          <h2>10. Privacy</h2>
          <p>Our Privacy Policy (available within the App) explains how we collect, use, and share your personal data. By using the App, you consent to such practices.</p>
        </section>

        <section className="legal-section">
          <h2>11. Termination</h2>
          <p>We may suspend or terminate your account if you violate these Terms. You may delete your account at any time via App settings. Upon termination, your content may be permanently removed.</p>
        </section>

        <section className="legal-section">
          <h2>12. Disclaimer of Warranties</h2>
          <p>The App is provided "as is" and "as available." myOmni LLC disclaims all warranties, including merchantability, fitness for a particular purpose, and non-infringement. We do not guarantee uninterrupted or error-free service.</p>
        </section>

        <section className="legal-section">
          <h2>13. Limitation of Liability</h2>
          <p>To the maximum extent permitted by law, myOmni LLC shall not be liable for any indirect, incidental, or consequential damages (e.g., lost profits, data loss) arising from your use of the App. Our total liability shall not exceed the amount you paid us (if any) in the past 6 months.</p>
        </section>

        <section className="legal-section">
          <h2>14. Indemnification</h2>
          <p>You agree to defend, indemnify, and hold harmless myOmni LLC, its members, employees, and affiliates from any claims, damages, or expenses arising from your content, violation of these Terms, or misuse of the App.</p>
        </section>

        <section className="legal-section">
          <h2>15. Governing Law and Dispute Resolution</h2>
          <p>These Terms are governed by the laws of Illinois, without regard to conflict of laws principles.</p>
          <p><strong>Dispute Resolution:</strong> Any dispute shall first be attempted to be resolved through informal negotiation. If unresolved, disputes shall be resolved through binding arbitration under the rules of the American Arbitration Association, unless prohibited by law. Class actions are waived.</p>
        </section>

        <section className="legal-section">
          <h2>16. Changes to These Terms</h2>
          <p>We may update these Terms periodically. We will notify you of material changes via in-app notice or email. Continued use after changes constitutes acceptance.</p>
        </section>

        <section className="legal-section">
          <h2>17. Contact Us</h2>
          <p>
            <strong>myOmni / Enhance Technology Solutions (FlexPrime)</strong><br />
            9266 Nagle Ave, Morton Grove, IL 60053<br />
            Email: <a href="mailto:support@my-omni.link">support@my-omni.link</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;
